const imageFields = ['log_license_image', 'log_image', 'log_url'];
const vehicleImageFields = ['log_vehicle_image_front', 'log_vehicle_image_right', 'log_vehicle_image_left', 'log_vehicle_image_back'];
const s3Host = /(?:^|\.)s3(?:[.-][a-z0-9-]+)*\.amazonaws\.com(?:\.cn)?$/i;

/** Signing parameters belong to display URLs, never to saved image references. */
export function canonicalVisitorImage(value: unknown): unknown {
  if (typeof value !== 'string') return value;
  try {
    const url = new URL(value);
    if (['https:', 'http:'].includes(url.protocol) && s3Host.test(url.hostname)) {
      // Slice the original string so encoded S3 object keys are preserved.
      return value.split(/[?#]/, 1)[0];
    }
  } catch { /* Relative image paths and non-URL values stay unchanged. */ }
  return value;
}

function vehicleImages(value: unknown): unknown {
  if (typeof value !== 'string') return value;
  try {
    const data = JSON.parse(value);
    if (!data || typeof data !== 'object' || Array.isArray(data)) return value;
    let changed = false;
    for (const field of vehicleImageFields) {
      if (field in data) {
        const canonical = canonicalVisitorImage(data[field]);
        changed = changed || canonical !== data[field];
        data[field] = canonical;
      }
    }
    return changed ? JSON.stringify(data) : value;
  } catch { return value; }
}

/** Copy the payload: previews keep their signed URLs for private image access. */
export function visitorLogSavePayload<T extends object>(input: T): T {
  const normalize = (key: string, value: unknown) => imageFields.includes(key)
    ? canonicalVisitorImage(value) : key === 'vehicle_details' ? vehicleImages(value) : value;
  if (input instanceof FormData) {
    const result = new FormData();
    input.forEach((value, key) => result.append(key, normalize(key, value) as string | Blob));
    return result as T;
  }
  return Object.fromEntries(Object.entries(input).map(([key, value]) => [key, normalize(key, value)])) as T;
}
